import { isInternalURL } from '@plone/volto/helpers/Url/Url';
import { MenuItemProps } from '@designsystem/stories/03-molecules/Menu';
import { NavItem } from '@fhnw/types/navItem';
import { normalizeLink } from './normalizeContent';

export const normalizeNavigation = (
  root: NavItem | NavItem[] | undefined,
): MenuItemProps[] => {
  if (Array.isArray(root)) {
    root = {
      items: root,
    } as NavItem;
  }
  if (!root || !root?.items?.length) {
    return [];
  }

  const normalized: MenuItemProps[] = root.items.map((item: NavItem) => ({
    label: item.title,
    href: normalizeLink(item.remoteUrl),
    items: normalizeNavigation(item),
    target: isInternalURL(item.remoteUrl) ? undefined : '_blank',
  }));

  return normalized;
};
